import { type ReactNode } from 'react';
import { PageLayout } from './PageLayout';
import { PageHeader } from './PageHeader';

export interface DashboardPageLayoutProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  contentBackground?: string;
}

export function DashboardPageLayout({
  title,
  subtitle,
  icon,
  actions,
  children,
  contentBackground,
}: DashboardPageLayoutProps) {
  return (
    <PageLayout
      variant="constrained"
      contentBackground={contentBackground}
      header={
        <PageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          actions={actions}
          borderStyle="bottom"
        />
      }
    >
      <div className="py-6 animate-fade-in">
        {children}
      </div>
    </PageLayout>
  );
}

export default DashboardPageLayout;
